(()=>{
const start=()=>{
const bar=document.querySelector('[data-ek-sticky-purchase]');
if(!bar||bar.dataset.purchaseReady)return;
bar.dataset.purchaseReady='true';
document.querySelectorAll('.ek-pdp-review .productView-moreItem').forEach(el=>{if(!el.children.length&&!el.textContent.trim())el.hidden=true;});
let mainBuy=document.querySelector('[data-ek-main-buy]');
const family=document.querySelector('[data-ekf]');
const nativeAdd=()=>document.querySelector('.productView-details .product-form__submit,#product-add-to-cart,[data-ekf-add]');
const productForm=()=>nativeAdd()?.closest('form');
const scope=()=>nativeAdd()?.closest('.shopify-section')||document.querySelector('.productView-details')||family;
const shown=el=>Boolean(el&&el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden'&&!el.closest('[hidden]'));
const purchaseTarget=()=>{
 const section=scope();
 if(!section)return null;
 const chosen=section.querySelector('.bxpay-card[aria-checked="true"]');
 const selector=chosen?.dataset.method==='cod'?'[data-brix-cod-btn]':'[data-brix-pay-online]';
 const payment=[...section.querySelectorAll('[data-brix-pay-cta] '+selector)].find(shown);
 if(payment)return payment;
 const native=[...section.querySelectorAll('.shiprocket-headless[data-type="product"],.shopify-payment-button__button--unbranded')].find(shown);
 if(native)return native;
 if(!chosen)return [...section.querySelectorAll('[data-brix-cod-slot] [data-brix-cod-btn]')].find(shown)||null;
 return null;
};
const add=bar.querySelector('[data-ek-sticky-add]'),buy=bar.querySelector('[data-ek-sticky-buy]');
const template=document.querySelector('[data-ek-pdp-cart-template]');
let observed,passed=false,busy=false,cartBusy=false,cart=null,cartControl=null,syncFrame;
const boundBuy=new WeakSet();
const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{for(const entry of entries){passed=!entry.isIntersecting;queueSync();}},{threshold:0}):null;
const messages=template?.dataset||{};
const statuses=()=>document.querySelectorAll('[data-ek-purchase-status],[data-ek-main-status]');
const message=text=>statuses().forEach(el=>{if(el.textContent!==text)el.textContent=text;});
const variantId=()=>productForm()?.querySelector('[name="id"]')?.value||family?.querySelector('[data-ekf-variant]')?.value||'';
const cartQuantity=()=>cart?.items?.filter(item=>String(item.variant_id||item.id)===String(variantId())).reduce((sum,item)=>sum+item.quantity,0)||0;
function mountCartControl(){
 if(cartControl?.isConnected||!template||!nativeAdd())return;
 cartControl=template.content.firstElementChild.cloneNode(true);
 const anchor=mainBuy||nativeAdd().closest('.productView-buttons')||nativeAdd().closest('product-form')||nativeAdd().closest('.ekf-purchase');
 if(!anchor)return;
 if(mainBuy)anchor.before(cartControl);else anchor.after(cartControl);
 const input=cartControl.querySelector('[data-ek-pdp-cart-quantity]');
 const update=async quantity=>{
  if(cartBusy||quantity===cartQuantity())return;
  const error=cartControl.querySelector('[data-ek-pdp-cart-status]');
  if(!Number.isSafeInteger(quantity)||quantity<0){input.value=cartQuantity();return;}
  cartBusy=true;error.textContent=messages.updating||'';syncCartControl();
  try{
   if(!window.EkCart)throw Error(messages.error);
   cart=await window.EkCart.setVariantQuantity(variantId(),quantity);
   error.textContent=messages.updated||'';
   if(!cartQuantity())nativeAdd()?.focus();
  }catch(failure){error.textContent=failure.message||messages.error||'';}
  finally{cartBusy=false;syncCartControl();}
 };
 cartControl.querySelector('[data-ek-pdp-cart-less]').addEventListener('click',()=>update(Math.max(0,cartQuantity()-1)));
 cartControl.querySelector('[data-ek-pdp-cart-more]').addEventListener('click',()=>update(cartQuantity()+1));
 input.addEventListener('change',()=>update(Number(input.value)));
 input.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();update(Number(input.value));}});
}
function syncCartControl(){
 mountCartControl();if(!cartControl)return;
 const quantity=cartQuantity(),hidden=quantity===0;
 if(cartControl.hidden!==hidden)cartControl.hidden=hidden;
 const input=cartControl.querySelector('[data-ek-pdp-cart-quantity]');
 if(document.activeElement!==input||!cartBusy)input.value=quantity;
 cartControl.querySelectorAll('button,input').forEach(el=>{if(el.disabled!==cartBusy)el.disabled=cartBusy;});
 cartControl.setAttribute('aria-busy',String(cartBusy));
}
function sync(){
 mainBuy=document.querySelector('[data-ek-main-buy]');
 if(mainBuy&&!boundBuy.has(mainBuy)){boundBuy.add(mainBuy);mainBuy.addEventListener('click',buyNow);}
 document.querySelectorAll('.productView-details [data-brix-pay-online]').forEach(button=>{
  const text=document.querySelector('[data-ek-prepaid-cta]')?.dataset.ekPrepaidCta;
  if(!text)return;
  const label=button.querySelector('[data-brix-cod-label]');
  if(label&&label.textContent!==text)label.textContent=text;
  if(button.dataset.ekPrepaidLabel!==text)button.dataset.ekPrepaidLabel=text;
  if(button.getAttribute('aria-label')!==text)button.setAttribute('aria-label',text);
  const line=label?.parentElement;
  if(line&&!line.querySelector('.ek-prepaid-bolt')){line.querySelector('svg')?.remove();const bolt=document.createElement('span');bolt.className='ek-prepaid-bolt';bolt.textContent='⚡';bolt.setAttribute('aria-hidden','true');line.prepend(bolt);}
  const setStyle=(el,name,value)=>{const probe=document.createElement('span').style;probe.setProperty(name,value,'important');const normalized=probe.getPropertyValue(name);if(el.style.getPropertyValue(name)!==normalized||el.style.getPropertyPriority(name)!=='important')el.style.setProperty(name,value,'important');};
  [['flex-direction','column'],['flex-wrap','nowrap'],['white-space','nowrap'],['font-size','15px'],['background','linear-gradient(155deg, #0875d0, #003e99)'],['color','#ffffff'],['border-radius','12px'],['min-height','48px'],['padding','8px 12px']].forEach(([name,value])=>setStyle(button,name,value));
  if(line){setStyle(line,'flex-direction','row');setStyle(line,'white-space','nowrap');setStyle(line,'gap','9px');}
  button.querySelectorAll('[data-brix-cod-sub]').forEach(sub=>{if(!sub.hidden)sub.hidden=true;});
 });
 if(mainBuy?.hidden)mainBuy.hidden=false;
 const atc=nativeAdd();
 if(atc&&atc!==observed){if(observed)observer?.unobserve(observed);observed=atc;observer?.observe(atc);}
 const blocked=!atc||atc.disabled||atc.getAttribute('aria-disabled')==='true';
 const target=purchaseTarget(),buyBlocked=blocked||busy||Boolean(target?.disabled)||target?.getAttribute('aria-disabled')==='true';
 if(add&&add.disabled!==(blocked||busy))add.disabled=blocked||busy;
 [buy,mainBuy].forEach(button=>{if(button&&button.disabled!==buyBlocked)button.disabled=buyBlocked;});
 const cartOpen=document.querySelector('#cc-overlay.active,dialog[open],.cart-drawer.is-open,.halo-cart-sidebar.is-open,[data-brix-cod-sheet]');
 const visible=passed&&!cartOpen&&!family;
 if(bar.hidden===visible)bar.hidden=!visible;
 if(document.body.classList.contains('ek-sticky-purchase-visible')!==visible)document.body.classList.toggle('ek-sticky-purchase-visible',visible);
 syncCartControl();
}
function queueSync(){if(syncFrame)return;syncFrame=requestAnimationFrame(()=>{syncFrame=0;sync();});}
add?.addEventListener('click',()=>{const target=nativeAdd();if(target&&!target.disabled)target.click();});
async function buyNow(){
 if(busy)return;
 const target=purchaseTarget();
 if(target){if(!target.disabled&&target.getAttribute('aria-disabled')!=='true')target.click();return;}
 const form=productForm();if(!form||!form.reportValidity())return;
 const data=new FormData(form),quantity=document.querySelector('.productView-details .quantity_selector input[name="quantity"]:not(:disabled)')||form.querySelector('input[name="quantity"]:not(:disabled)');
 if(quantity)data.set('quantity',quantity.value);
 if(!data.get('id'))return;
 busy=true;message('');sync();
 try{
  const root=window.Shopify?.routes?.root||'/';
  if(window.EkCart){cart=await window.EkCart.addForm(data);await window.EkCart.open();}
  else{const response=await fetch(root+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});const result=await response.json();if(!response.ok)throw Error(result.description||messages.error||bar.dataset.error);location.assign(root+'cart');}
 }catch(error){message(error.message||messages.error||bar.dataset.error||'');}
 finally{busy=false;sync();}
}
buy?.addEventListener('click',buyNow);
document.addEventListener('ek:cart-updated',event=>{if(event.detail?.cart)cart=event.detail.cart;queueSync();});
document.addEventListener('change',queueSync);
document.addEventListener('shopify:section:load',queueSync);
document.addEventListener('scroll',queueSync,{passive:true});
const details=document.querySelector('.halo-productView-right')||document.querySelector('.productView-details')||family;
if(details)new MutationObserver(queueSync).observe(details,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-checked','class','style','hidden','value']});
const overlay=document.getElementById('cc-overlay');if(overlay)new MutationObserver(queueSync).observe(overlay,{attributes:true,attributeFilter:['class']});
if(window.EkCart)window.EkCart.read().then(value=>{cart=value;queueSync();}).catch(()=>{});
sync();
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
document.addEventListener('shopify:section:load',start);
})();
document.addEventListener('click',event=>{const link=event.target.closest('a[href="#ek-store-reviews"],[data-ek-open-reviews]');if(!link)return;const details=document.getElementById('ek-store-review-list');if(!details)return;details.open=true;event.preventDefault();const section=document.getElementById('ek-store-reviews');section.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});section.focus({preventScroll:true});});
